export default "__VITE_ASSET__8dtodT3k__"